import type { ScenarioConfig } from "@air-defence-sim/sim-core";

export type Preset = {
  id: string;
  label: string;
  description: string;
  config: Partial<ScenarioConfig>;
};

export const PRESETS: Preset[] = [
  {
    id: "standard",
    label: "Standard saturation",
    description: "Sustained four-wave attack on a balanced country layout. The default scenario.",
    config: {
      targetDistribution: "country",
      attackerWaveCount: 4,
      attackerWaveSpacing: 2.5,
      attackerWeaponsPerWave: 6,
      attackerConcentration: 0.5,
      warningRangeMultiplier: 1.5,
      mobileDefenceBudgetShare: 0.6,
      totalDefenceBudget: 1500,
      targetValueEntropy: 0.5,
    },
  },
  {
    id: "surprise",
    label: "Surprise volley",
    description: "Single dense salvo with limited warning. No second engagement window.",
    config: {
      targetDistribution: "country",
      attackerWaveCount: 1,
      attackerWaveSpacing: 30,
      attackerWeaponsPerWave: 16,
      attackerConcentration: 0.6,
      warningRangeMultiplier: 0.5,
      mobileDefenceBudgetShare: 0.5,
      totalDefenceBudget: 1500,
      targetValueEntropy: 0.5,
    },
  },
  {
    id: "capital",
    label: "Capital strike",
    description: "Heavy concentration on the highest-value city. Tests fixed-point defence.",
    config: {
      targetDistribution: "country",
      attackerWaveCount: 3,
      attackerWaveSpacing: 2.5,
      attackerWeaponsPerWave: 8,
      attackerConcentration: 0.95,
      warningRangeMultiplier: 1.5,
      mobileDefenceBudgetShare: 0.4,
      totalDefenceBudget: 1500,
      targetValueEntropy: 0.3,
    },
  },
  {
    id: "distributed",
    label: "Distributed precision",
    description: "Many small targets, low concentration. Tests mobile / networked defence.",
    config: {
      targetDistribution: "country",
      attackerWaveCount: 4,
      attackerWaveSpacing: 2.5,
      attackerWeaponsPerWave: 5,
      attackerConcentration: 0.1,
      warningRangeMultiplier: 1.5,
      mobileDefenceBudgetShare: 0.7,
      totalDefenceBudget: 1500,
      targetValueEntropy: 0.85,
    },
  },
  {
    id: "early-warning",
    label: "Forward-warning success",
    description: "Generous warning, mobile-heavy allocation, larger budget. Defender's-favour.",
    config: {
      targetDistribution: "country",
      attackerWaveCount: 4,
      attackerWaveSpacing: 2.5,
      attackerWeaponsPerWave: 6,
      attackerConcentration: 0.5,
      warningRangeMultiplier: 3,
      mobileDefenceBudgetShare: 0.7,
      totalDefenceBudget: 1800,
      targetValueEntropy: 0.5,
    },
  },
  {
    id: "overload",
    label: "Saturation overload",
    description: "Four waves of eight weapons. Defence will be magazine-stressed.",
    config: {
      targetDistribution: "country",
      attackerWaveCount: 4,
      attackerWaveSpacing: 2.5,
      attackerWeaponsPerWave: 8,
      attackerConcentration: 0.5,
      warningRangeMultiplier: 1.5,
      mobileDefenceBudgetShare: 0.6,
      totalDefenceBudget: 1500,
      targetValueEntropy: 0.5,
    },
  },
];
